/* ak-motion.js — loading screen + fade-in reveals. Loaded by layout/theme.liquid and layout/password.liquid.
   Nothing is hidden unless this script runs: elements only get [data-reveal] from here. */
(function () {
  'use strict';
  var d = document.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var loader = document.getElementById('ak-loader');
  var full = d.classList.contains('ak-full');

  /* ---------- 1. tag reveal units ---------- */
  var SEL = [
    'main h1', 'main h2', 'main .sec-lead', 'main .hero-logo', 'main .pc', 'main .product-card', 'main .mini-tile',
    'main .lb-tile', 'main .lb-head > *', 'main .community-tile', 'main .pdp-media', 'main .pdp-info > *',
    'main .collection-header > *', 'main .filter-bar', 'main .art-entry', 'main .soul-image', 'main .soul-body > *',
    'main .contact-page > *', 'main .newsletter-form', 'main .stub-page > *', 'main .split-link', 'main .cart-page > *',
    'footer .footer-row > *', 'footer .footer-meta'
  ].join(',');
  var units = [];
  Array.prototype.forEach.call(document.querySelectorAll(SEL), function (el) {
    if (el.parentElement && el.parentElement.closest('[data-reveal]')) return;
    el.setAttribute('data-reveal', '');
    units.push(el);
  });
  // stagger within the same parent
  var counts = new Map();
  units.forEach(function (el) {
    var n = counts.get(el.parentElement) || 0;
    counts.set(el.parentElement, n + 1);
    el.style.setProperty('--d', Math.min(n, 9) * 80 + 'ms');
  });
  d.classList.add('ak-motion');

  var started = false, io = null;
  function show(el) { el.classList.add('is-in'); }
  function startReveals() {
    if (started) return; started = true;
    if (reduce || !('IntersectionObserver' in window)) { units.forEach(show); return; }
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    units.forEach(function (el) { io.observe(el); });
    // fast scrolling / jumps can skip elements: anything already above the fold line is revealed so no gaps are left behind
    var ticking = false;
    var sweep = function () {
      ticking = false;
      var atEnd = window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 6;
      units.forEach(function (el) {
        if (el.classList.contains('is-in')) return;
        if (atEnd || el.getBoundingClientRect().top < window.innerHeight * 0.92) { show(el); if (io) io.unobserve(el); }
      });
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(sweep); } }, { passive: true });
  }

  /* ---------- 2. loading screen ---------- */
  function finishLoader() {
    try { sessionStorage.setItem('ak_seen', '1'); } catch (e) {}
    d.classList.add('ak-ready');
    if (!loader) { startReveals(); return; }
    setTimeout(startReveals, reduce ? 0 : 380);
    setTimeout(function () { if (loader && loader.parentNode) loader.parentNode.removeChild(loader); }, 1500);
  }
  if (!loader || reduce) { if (loader) loader.style.display = 'none'; finishLoader(); return; }

  var cnt = document.getElementById('ak-loader-count');
  var bar = document.getElementById('ak-loader-bar');
  var minMs = full ? 2300 : 700;
  var t0 = performance.now(), loaded = document.readyState === 'complete', shown = 0, ended = false;
  window.addEventListener('load', function () { loaded = true; });
  function ease(x) { return 1 - Math.pow(1 - x, 3); }
  (function frame(now) {
    var t = Math.min((now - t0) / minMs, 1);
    var p = ease(t);
    if (!loaded) p = Math.min(p, 0.9);
    shown += (p - shown) * 0.2;
    var pct = Math.round(shown * 100);
    if (cnt) cnt.textContent = String(pct).padStart(3, '0');
    if (bar) bar.style.transform = 'scaleX(' + shown.toFixed(4) + ')';
    if (!ended && t >= 1 && loaded && pct >= 99) {
      ended = true;
      if (cnt) cnt.textContent = '100';
      if (bar) bar.style.transform = 'scaleX(1)';
      setTimeout(finishLoader, full ? 420 : 120);
      return;
    }
    requestAnimationFrame(frame);
  })(t0);
})();
